import {makeStyles} from "@material-ui/core/styles";

const StyleResultLayout = makeStyles((theme) => ({
    buttonRetakeQuiz: {
        backgroundColor: '#ED3237',
        color: '#fff',
        width: '300px',
        height: '42px',
        borderRadius: '50px'
    },
    noResult: {
        position: 'absolute',
        top: "50%",
        left: "50%",
        transform: 'translate(-50%, -50%)',
        width: "100%",
        textAlign: "center"
    }
}));

export default StyleResultLayout;